import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as emailPackApi from '../Api/emailPackApi';

const EMAIL_PACK_KEY = 'emailPacks';

export const useEmailPackProducts = () =>
	useQuery({
		queryKey: [EMAIL_PACK_KEY, 'products'],
		queryFn: () => emailPackApi.getEmailPackProducts().then((res) => res.data?.data || []),
		staleTime: 5 * 60 * 1000,
	});

export const useEmailPackSummary = (companyId) =>
	useQuery({
		queryKey: [EMAIL_PACK_KEY, 'summary', companyId],
		queryFn: () =>
			emailPackApi.getEmailPackSummary(companyId).then((res) => res.data?.data),
		enabled: !!companyId,
		staleTime: 60 * 1000,
	});

export const useEmailPackCheckout = () =>
	useMutation({
		mutationFn: (payload) =>
			emailPackApi.createEmailPackCheckout(payload).then((res) => res.data?.data),
	});

export const useEmailPackPaymentIntent = () =>
	useMutation({
		mutationFn: (payload) =>
			emailPackApi.createEmailPackPaymentIntent(payload).then((res) => res.data?.data),
	});

export const useConfirmEmailPackPurchase = (companyId) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (payload) =>
			emailPackApi.confirmEmailPackPurchase(payload).then((res) => res.data?.data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMAIL_PACK_KEY, 'summary', companyId] });
			queryClient.invalidateQueries({ queryKey: ['sendGridSubuser'] });
		},
	});
};

export const useSyncEmailPackLimits = (companyId) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => emailPackApi.syncEmailPackLimits(companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [EMAIL_PACK_KEY, 'summary', companyId] });
			queryClient.invalidateQueries({ queryKey: ['sendGridSubuser'] });
		},
	});
};
